import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}><path d="M18 16.6l-5.8-5.8c.8-1.1 1.3-2.5 1.3-4 0-3.7-3-6.8-6.8-6.8C3 0 0 3 0 6.8c0 3.7 3 6.8 6.8 6.8 1.5 0 2.9-.5 4-1.3l5.8 5.8 1.4-1.5zM6.8 12c-2.9 0-5.3-2.4-5.3-5.2s2.4-5.2 5.3-5.2 5.3 2.4 5.3 5.2S9.7 12 6.8 12z" /></svg>);